import { useRootStore } from './useRootStore';

export function useUserStore() {
  const { userStore } = useRootStore();
  return userStore;
}
